module.exports = __webpack_public_path__ + "static/media/me.bc9ce17f.jpg";